import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import ListMerchants from './List/AsyncList';
import ShowMerchant from './ShowMerchant';
import UpdateMerchant from './UpdateMerchant';

function Routes() {
  return (
    <DocumentTitle title="Merchants">
      <Route path="/merchants" exact component={ListMerchants} />
      <Route path="/merchants/:id/show" component={ShowMerchant} />
      <Route path="/merchants/:id/edit" component={UpdateMerchant} />
    </DocumentTitle>
  );
}

export default Routes;
